"use strict";
import { notesLayer as notesLayerStore } from "../store";
export default function () {
    let layer;
    notesLayerStore.subscribe(value => {
        layer = value;
    });
    layer.clearLayers();
}
